/**
 * Runtime config: uses window.APP_CONFIG (from Config.js at deploy time) when available,
 * otherwise falls back to static config.json.
 *
 * When the portal is opened from a phone/LAN IP (e.g. http://192.168.1.74:3000)
 * but SERVER_URL still points at 127.0.0.1, rewrite the API host to the page host
 * so requests hit the PC, not the phone itself.
 */
import staticConfig from './config.json';

const runtime =
    typeof window !== 'undefined' && window.APP_CONFIG ? window.APP_CONFIG : {};
const merged = { ...staticConfig, ...runtime };

function rewriteLocalApiHost(url) {
    if (typeof window === 'undefined' || !url) return url;
    try {
        const parsed = new URL(url, window.location.origin);
        const apiIsLoopback =
            parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';
        const pageHost = window.location.hostname;
        const pageIsLoopback =
            pageHost === 'localhost' || pageHost === '127.0.0.1';
        if (apiIsLoopback && !pageIsLoopback) {
            parsed.hostname = pageHost;
            return parsed.href;
        }
    } catch (_) {
        /* keep original */
    }
    return url;
}

merged.SERVER_URL = rewriteLocalApiHost(merged.SERVER_URL);
merged.SERVER_URL_IMGUpload = rewriteLocalApiHost(merged.SERVER_URL_IMGUpload);

export default merged;
